<script setup>
import { useGlobalStore } from "@stores/global";
import IconEye from "@components/icons/Eye.vue";

const props = defineProps({
    clips: { type: Array, default: () => [] },
    cityName: { type: String, default: "" },
});

const globalStore = useGlobalStore();

const open = (clip) => {
    globalStore.setModal([
        "clip",
        { clip, cityName: props.cityName },
        true,
        true,
        true,
    ]);
};
</script>

<template>
    <ul v-if="clips.length" class="flex flex-col gap-2">
        <li v-for="(clip, i) in clips" :key="i" data-reveal>
            <button
                type="button"
                class="flex w-full cursor-pointer flex-col text-left"
                @click="open(clip)"
            >
                <img
                    :src="clip.poster"
                    :alt="clip.title"
                    class="bg-marine-400 aspect-video w-full object-cover"
                />
                <div class="bg-marine-600 flex w-full flex-col gap-2 p-3">
                    <p class="body-md leading-none font-bold uppercase">
                        {{ clip.title }}
                    </p>
                </div>
            </button>
        </li>
    </ul>
</template>
